import React from 'react';
import { useTheme } from '@mui/material';

import nrcclogo from './nrcc.png'
import acislogo from './acis-transparent.png'
import hublogo from './climate-hub-logo.png'

import './footer.styles.scss';

export default function Footer() {
  const theme = useTheme();

  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ '--primary-color': theme.palette.primary.main }}>
      <div>
        <p>This site is a collaboration between the following partners:</p>
      </div>
      <div className='logos-container'>
        <a href="https://www.nrcc.cornell.edu/" target="_blank" rel="noopener noreferrer"><img src={nrcclogo} alt="Logo for the Northeast Regional Climate Center (NRCC)" /></a>
        <a href="https://www.rcc-acis.org" target="_blank" rel="noopener noreferrer"><img src={acislogo} alt="Logo for the Applied Climate Information System (ACIS)" /></a>
        <a href="https://www.climatehubs.usda.gov" target="_blank" rel="noopener noreferrer"><img src={hublogo} alt="Logo for USDA Climate Hubs" /></a>
      </div>
      <div>
        <p>© {currentYear} Cornell University</p>
      </div>
    </footer>
  );
}